import { defineStore } from 'pinia'
import type { ResGetDeviceInfoResult } from '@/types/accessor/api/device/deviceInfoTypes'
interface State {
  // 【デバイス認証】デバイス認証がされているかどうか
  deviceAuthFlag: boolean
  // 【デバイス認証】デバイス情報
  deviceInfo: ResGetDeviceInfoResult
}

/**
 * フロントエンド側で一時的にデータを保存する際に、使用する
 * @param なし
 * @returns なし
 */
export const useHoldTemporaryStore = defineStore('holdTemporaryStore', {
  state: (): State => ({
    deviceAuthFlag: false,
    deviceInfo: {
      deviceId: '',
      deviceName: '',
      memo: '',
      permissionStatus: '',
      addedDateTime: undefined
    }
  }),
  getters: {
    getDeviceAuthFlag: state => state.deviceAuthFlag,
    getDeviceInfo: state => state.deviceInfo
  },
  actions: {
    // 【デバイス認証】
    changeDeviceAuthFlag(value: boolean) {
      this.deviceAuthFlag = value
    },
    // 【デバイス認証】
    changeDeviceInfo(value: ResGetDeviceInfoResult) {
      this.deviceInfo = value
    }
  }
})
